import { registerAllViews, renderAppShell } from "@org-avp/avp-avengers-ui-app-shell";
// TODO:AVENGERS-1779 Re-enable after electron-client is fixed.
//  - This code commented out due to we have to avoid calls to the new api method:
//  The old electon-client fails on incoming calls on unknow/unhandled api method.
// import { getElectronAPI } from "@org-avp/avp-avengers-ui-framework-electron-api";
// import { initLogIntercept } from "./log-intercept";
//
// const electronAPI = getElectronAPI();
// if (electronAPI != null) {
//   initLogIntercept(electronAPI);
// }

const rootEl = document.getElementById("root");
if (rootEl !== null && rootEl !== undefined) {
  console.log("View registration starting...");
  registerAllViews().then((viewCount) => {
    console.log(`View registration complete (${viewCount} views)`);
    renderAppShell(rootEl);
  });
}
